import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import Lockable from "components/Lockable";
import UniversalModalOverride from "../../../../../components/UniversalModalOverride";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Dispositions',
		url: '/dispositions',
		icon: 'upload',
	},
	{
		name: 'Pending 4473s',
		url: '/dispositions/pendings',
		icon: 'ellipsis-h',
	},
];

 class Pendings extends Lockable {

	handleOnePageClick = () => this.props.history.push('/dispositions/one_page')

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.handleOnePageClick} size={"sm"} color="primary">
						<i className="fa fa-upload"/>&nbsp;&nbsp;Start New 4473
					</Button>
				</Framework.Components.PageBar>

				<Collections.DispositionPendingsKiosks
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					kiosks={this.props.kiosks}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					handleSetPin = {this.handleSetPin}
				/>

				<Collections.DispositionPendingsFirearms
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					kiosks={this.props.kiosks}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<div className={'row'}>
					<div className={'col-sm-4 offset-4'}>
						<p className={'text-center'} style={{fontSize: '12px'}}>
							Pending dispositions can be <b>Sent to Kiosk</b> for re-editing by customer on a pin locked device.
							Select <b>Edit Previous</b> on a pin locked device to allow a customer to resume editing the 4473.
							<b>Cancel Editing</b> to move a pending 4473 out of Kiosk editing.
							To complete a 4473 click <b>Review 4473</b> or <b>Reopen 4473</b>.
						</p>
					</div>
				</div>

			</div>
		);
	}
}
export default Framework.Components.withRootState(Pendings);